import React from "react";
import { CToast,CToastBody,CToastClose,CToastHeader,CButton,CToaster} from '@coreui/react'
import { useState,useRef } from "react";

const Toast = (props) => {

    const [toast, addToast] = useState(0)
    const toaster = useRef()
    const exampleToast = (
      <CToast title="MHIS" autohide={true}>
        <CToastHeader close>
          <svg
            className="rounded me-2"
            width="20"
            height="20"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid slice"
            focusable="false"
            role="img"
          >
            <rect width="100%" height="100%" fill="#007aff"></rect>
          </svg>
          <strong className="me-auto">Mhis</strong>
          <CToastClose className="me-2 m-auto" />
        </CToastHeader>
        <CToastBody>Salvataggio Effettuato.</CToastBody>
       
      </CToast>
    )
    return (
      <>
        <CButton onClick={() => addToast(exampleToast)} id="toastButton" style={{display:"none"}}>Send a toast</CButton>
        <CToaster ref={toaster} push={toast} placement="top-end" />
      </>
    )
}

export default Toast